import {SpaceProto} from "../space-proto";
import {NavigationButtonPosition, NavigationSectionType} from "../../navigation/@const";
import Navigation_ButtonGenericDeprecated from "../../../../layout/navigation/buttons/generic-section";
import {navigationStructureOnClick} from "../../navigation/actions/navigation-structure-on-click";
import MainMenu_Users from "../../../../layout/menu/sections/users/menu-users";
import {GroupedData} from "../../../data-structures/group";
import {SortDirection} from "../../../data-structures/sort";
import NavigationMenu_UsersContent from "../../../../layout/menu/sections/users/menu-content";


export class SpaceUsers extends SpaceProto {

    constructor() {
        super(NavigationSectionType.USERS)

        this.title              = "Users"
        this.svgIcon            = "isvg-users"

        this.defaultPosition    = NavigationButtonPosition.MORE
    }

    onClick = () => {
        navigationStructureOnClick(this.navigation)
    }

    get enabled():boolean {
        return gd.ac.check.company.isUser(gd.companyId) && gd.ac.components.hasAccess('users')
    }

    get navigationStructureConfig() {
        return {
            id                  : this.id,
            icon                : "i5-nav-users",
            iconActive          : "i5-nav-users-solid",
            hint                : gd.t('menu.users.hint'),
            type                : NavigationSectionType.USERS,
            keyboardShortcut    : 'U',
            renderComponent     : Navigation_ButtonGenericDeprecated,
            menuComponent       : MainMenu_Users,
            menuContent         : NavigationMenu_UsersContent,
            onClick             : this.onClick,
            position            : this.position //(NavigationSectionType.USERS)
        }
    }

    search(keyword: string): GroupedData {
        const allCompanyUsers = gd.session.companyUsers.searchCompanyUsersByName(keyword)

        const result:GroupedData = _(allCompanyUsers)
            .groupBy((model)=>{
                return model.departmentId || null
            })
            .toPairs()
            .map((group)=> {
                const department = gd.session.departments.get(group[0])

                return {
                    value       : department,
                    sortValue   : department?.name || 'None',
                    label       : department?.name || 'None',
                    items       : group[1]
                }
            })
            .orderBy(group=>group.sortValue, SortDirection.ASC as any)
            .value() as GroupedData;

        return result
    }

}
